import { defineModule } from "direct-vuex";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { MailContentModel } from "@/models/api/administration/mailBox/mailContentModel";
import { MailBox } from "@/models/api/mail/NotificationData";
import { MailContentKey } from "@/models/api/administration/mailBox/mailContentKey";
import {
  getMailBoxListForContent,
  getMailContent,
  postSaveMailContent,
  postDeleteMailContent,
  getContractorMailContentKeyList,
} from "@/requests/mailBox";
import { MailContent } from "@/models/api/administration/mailBox/mailContent";

export interface AdministrationContractorCustomMailContentInterface {
  isMailBoxTableLoading: boolean;
  mailBoxTableData: Array<MailBox>;
  selectedMailBoxId: number | null;
  isMailContentTableLoading: boolean;
  mailContentTableData: Array<MailContentKey>;
  selectedMailContentKey: number | null;
  content: MailContentModel;
}

export const AdministrationContractorCustomMailContentState: AdministrationContractorCustomMailContentInterface = {
  isMailBoxTableLoading: false,
  mailBoxTableData: [],
  selectedMailBoxId: null,
  isMailContentTableLoading: false,
  mailContentTableData: [],
  selectedMailContentKey: null,
  content: new MailContentModel(),
};

const AdministrationContractorCustomMailContentModule = defineModule({
  state: AdministrationContractorCustomMailContentState as AdministrationContractorCustomMailContentInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setMailContent(state, props: MailContentModel) {
      state.content = props;
    },
    setSelectedMailContentKey(state, param: number | null) {
      state.selectedMailContentKey = param;
    },
    setSelectedMailBoxId(state, param: number | null) {
      state.selectedMailBoxId = param;
    },
    setIsMailContentTableLoading(state, param: boolean) {
      state.isMailContentTableLoading = param;
    },
    setMailBoxTableData(state, param: Array<MailBox>) {
      state.mailBoxTableData = param;
    },
    setMailContentTableData(state, param: Array<MailContentKey>) {
      state.mailContentTableData = param;
    },
    setIsMailBoxTableLoading(state, param: boolean) {
      state.isMailBoxTableLoading = param;
    },
  },
  actions: {
    async downloadMailContentKeyList(context) {
      const { commit } = _moduleActionContext(context);
      commit.setIsMailContentTableLoading(true);
      const response = await getContractorMailContentKeyList();
      commit.setMailContentTableData(response);
      if (response.length > 0) {
        commit.setSelectedMailContentKey(response[0].keyId);
      } else {
        commit.setSelectedMailContentKey(null);
      }
      commit.setIsMailContentTableLoading(false);
    },
    async downloadMailBoxList(context) {
      const { commit } = _moduleActionContext(context);
      commit.setIsMailBoxTableLoading(true);
      const response = await getMailBoxListForContent();
      commit.setMailBoxTableData(response);
      if (response.length > 0) {
        commit.setSelectedMailBoxId(response[0].id);
      } else {
        commit.setSelectedMailBoxId(null);
      }
      commit.setIsMailBoxTableLoading(false);
    },
    async downloadContractorMailContent(context, params: string) {
      const { commit, state } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        requests.contractorId = params;
        const response = await getMailContent(requests);
        commit.setMailContent(response);
      }
    },
    async saveContractorMailContent(context, params: string) {
      const { state } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        requests.mailContents = state.content.mailContent;
        requests.contractorId = params;
        await postSaveMailContent(requests);
      }
    },
    async deleteContractorMailContent(context, params: string) {
      const { state, dispatch } = _moduleActionContext(context);
      if (state.selectedMailContentKey != null) {
        const requests = new MailContent();
        requests.mailConfigurationId = state.selectedMailBoxId == 0 ? null : state.selectedMailBoxId;
        requests.mailContentKeyEnum = state.selectedMailContentKey;
        requests.contractorId = params;
        await postDeleteMailContent(requests);
        dispatch.downloadContractorMailContent(params);
      }
    },
  },
});

export default AdministrationContractorCustomMailContentModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, AdministrationContractorCustomMailContentModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationContractorCustomMailContentModule);
